/** Remaining share of a page's display time, in percent (0–100). */
export function progressPercent(timeleftMs: number, totalSeconds: number): number {
  if (!Number.isFinite(timeleftMs) || !Number.isFinite(totalSeconds) || totalSeconds <= 0) {
    return 0;
  }
  return Math.min(100, Math.max(0, ((timeleftMs / 1000) * 100) / totalSeconds));
}
